import FormattedMessage from 'I18n/components/FormattedMessage';
import withUsageTracking from 'editor-components/hoc/withUsageTracking';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { RedoIcon, UndoIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EPUndoRedoButtons = ({
  buttonGroupProps = {},
  buttonSize = 'small',
  buttonUse = 'tertiary',
  canRedo = false,
  canUndo = false,
  disabled = false,
  iconSize = '300',
  onUndo,
  onRedo,
  onTrackUsage,
  tooltipPlacement
}) => {
  function handleUndoClick() {
    onUndo();
    onTrackUsage('undo click');
  }
  function handleRedoClick() {
    onRedo();
    onTrackUsage('redo click');
  }
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "undo-redo-buttons",
    children: /*#__PURE__*/_jsxs(ButtonGroup, Object.assign({}, buttonGroupProps, {
      children: [/*#__PURE__*/_jsx(IconButton, {
        "data-action": "undo",
        disabled: !canUndo || disabled,
        size: buttonSize,
        onClick: handleUndoClick,
        placement: tooltipPlacement,
        tooltip: !disabled && /*#__PURE__*/_jsx(FormattedMessage, {
          message: canUndo ? 'epUndoRedoButtons.canUndo' : 'epUndoRedoButtons.cannotUndo'
        }),
        use: buttonUse,
        children: /*#__PURE__*/_jsx(UndoIcon, {
          size: iconSize
        })
      }), /*#__PURE__*/_jsx(IconButton, {
        "data-action": "redo",
        disabled: !canRedo || disabled,
        size: buttonSize,
        onClick: handleRedoClick,
        placement: tooltipPlacement,
        tooltip: !disabled && /*#__PURE__*/_jsx(FormattedMessage, {
          message: canRedo ? 'epUndoRedoButtons.canRedo' : 'epUndoRedoButtons.cannotRedo'
        }),
        use: buttonUse,
        children: /*#__PURE__*/_jsx(RedoIcon, {
          size: iconSize
        })
      })]
    }))
  });
};
export default withUsageTracking(EPUndoRedoButtons);